import r from"./_arrayMap.js";import o from"./_copyArray.js";import t from"./isArray.js";import m from"./isSymbol.js";import i from"./_stringToPath.js";import s from"./_toKey.js";import p from"./toString.js";function f(f){return t(f)?r(f,s):m(f)?[f]:o(i(p(f)))}export{f as default};
//# sourceMappingURL=toPath.js.map
